import {Injectable} from '@angular/core';
import {PreviewDataSourceInfo} from '../../../../data-source/models/preview-data-source-info.model';
import {DataSourceRowNumber} from '../../../../data-source/models/data-source-row-number.type';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../../environments/environment';
import {ColumnsType} from '../../../../data-source/models/columns-type.model';
import {ConnectionType} from '../../../../main/modules/management/models/connection.type';
import {OracleBodyReq} from '../interfaces/i-data-source-preview';
import {ReplaceWithSqlConnectionModel} from '../../../models/replace-with-sql.model';
import {ReplaceExcelWithSqlConnectionModelConnectionSelectableDto} from '../../../models/replace-with-sql.model';

@Injectable({
  providedIn: 'root',
})
export class DataSourcePreviewApi {
  api = environment.api;
  constructor(private http: HttpClient) { }

  getFilePreviewTableContent(
    workspaceId: string,
    previewDataSourceInfo: PreviewDataSourceInfo,rowNumber: DataSourceRowNumber,sheetName: string): Observable<any> {
    const requestBody = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      filePath: previewDataSourceInfo.filePath,
      sheetName,
      rowNumber,
    };
    return this.http.post<any>(this.api + '/DataSource/GetFilePreviewData', requestBody);
  }

  getReplacementDataSourcePreviewData(workspaceId: string, previewDataSourceInfo: Partial<PreviewDataSourceInfo>,
                                      rowNumber: DataSourceRowNumber, sheetName: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      filePath: previewDataSourceInfo.filePath,
      fileName: previewDataSourceInfo.fileName,
      rowNumber,
      sheetName,
    };
    return this.http.post(`${this.api}/DataSource/GetReplacementDataSourcePreviewData`, bodyRequest);
  }

  getWebServicePreviewTableContent(
    workspaceId: string,previewDataSourceInfo: PreviewDataSourceInfo,rowNumber: DataSourceRowNumber): Observable<any> {
    const requestBody = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      rowNumber,
    };
    return this.http.post<any>(this.api + '/DataSource/GetWebServicePreviewData', requestBody);
  }

  getSqlServerPreviewTableContent(
    workspaceId: string,previewDataSourceInfo: PreviewDataSourceInfo,rowNumber: DataSourceRowNumber): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      rowNumber,
    };
    return this.http.post<any>(this.api + '/DataSource/GetSqlServerPreviewData', bodyRequest);
  }

  getExcelSheetsNamesPreview(dataSourceId: string, filePath: string): Observable<any> {
    const bodyRequest = {
      filePath,
      dataSourceId,
    };
    return this.http.post(`${this.api}/DataSource/GetExcelSheetsNamesPreview`,bodyRequest);
  }

  getOraclePreviewTableContent(
      workspaceId: string,previewDataSourceInfo: PreviewDataSourceInfo,rowNumber: DataSourceRowNumber): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      rowNumber,
    };
    return this.http.post<any>(`${this.api}/DataSource/GetOraclePreviewData`, bodyRequest);
  }

  getDataSources(workspaceId: string, searchKey: string, column: string, ascending: boolean, pageNumber: number,
                 pageSize: number, needCount: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      searchKey,
      column,
      ascending,
      pageNumber,
      pageSize,
      needCount,
    };
    return this.http.post<any>(this.api + '/DataSource/GetDataSources', bodyRequest);
  }

  deletePreviewConnection(previewDataSourceInfo: PreviewDataSourceInfo): Observable<any> {
    const bodyRequest = {
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      filePath: previewDataSourceInfo.filePath,
    };
    return this.http.post<any>(`${this.api}/DataSource/DeleteDataSourcePreviewAndConnection/`, bodyRequest);
  }

  deletePreviewReplacementConnection(previewDataSourceInfo: PreviewDataSourceInfo): Observable<any> {
    const bodyRequest = {
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      filePath: previewDataSourceInfo.filePath,
    };
    return this.http.post<any>(`${this.api}/DataSource/DeleteReplacementDataSourcePreviewAndConnection`, bodyRequest);
  }

  createDataSourceTable(previewDataSourceInfo: PreviewDataSourceInfo, workspaceId: string,
                        columnsTypes: ColumnsType, sheetName: string, fromDashboard: boolean,
                        dashboardId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      connectionId: previewDataSourceInfo.connectionId,
      dbConnectionType: previewDataSourceInfo.dbConnectionType,
      filePath: previewDataSourceInfo.filePath,
      columnsTypes: this.arrayToObjectConvertor(columnsTypes),
      fromDashboard,
      sheetName,
      dashboardId,
    };
    return this.http.post(`${this.api}/DataSource/CreateDataSourceTable/`, bodyRequest);
  }

  createSqlServerConnection(workspaceId: string, name: string, serverAddress: string, portNumber: string,
                            dbName: string, windowsAuth: boolean, username: string, password: string,
                            commandTimeout: number, sqlStatement: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      name,
      serverAddress,
      portNumber,
      dbName,
      windowsAuth,
      username,
      password,
      commandTimeout,
      sqlStatement,
    };
    return this.http.post<any>(`${this.api}/DataSource/CreateSQLServerConnection/`, bodyRequest);
  }

  getSqlServerConnection(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api + '/DataSource/GetSqlServerConnection', bodyRequest);
  }

  updateSqlServerConnection(workspaceId: string, dataSourceId: string, connectionId: string, name: string,
                            serverAddress: string, portNumber: string,
                            dbName: string, windowsAuth: boolean, username: string, password: string,numberOfRowLimited: string,hasRowLimited: boolean, 
                            commandTimeout: number, sqlStatement: string): Observable<any> {
    const bodyRequest = {
      connectionType: 'Queryable',
      workspaceId,
      dataSourceId,
      connectionId,
      name,
      serverAddress,
      portNumber,
      dbName,
      windowsAuth,
      username,
      password,
      commandTimeout,
      sqlStatement,
      numberOfRowLimited,
      hasRowLimited
    };
    return this.http.post<any>(`${this.api}/DataSource/UpdateSQLServerConnection/`, bodyRequest);

  }

  convertNewConnectionToAvailableDBConnection(workspaceId: string, dataSourceId: string, connectionId: string, payload: {
    tableId: string;
    tableName: string;
    dbConnectionId: string;
    dataSourceName: string;
    connectionType: ConnectionType;
    hasRowLimited: boolean;
    numberOfRowLimited: string;
    hasTopN: boolean;
    numberOfTopN: string;
    windowsAuth: boolean;
    serverAddress: string;
    dbName: string;
    password: string;
    commandTimeout: number;
    connectionName: string;
    portNumber: string;
    sqlStatement: string;
    username: string;
  }): Observable<any> {
    const splitedTableName = payload.tableName.split('.')
    const bodyRequest = {
      connectionType: 'Queryable',
      workspaceId,
      dataSourceId,
      connectionId,
      ...payload,
      tableName: '['+splitedTableName[0]+'].'+'['+splitedTableName[1]+']',
    };
    return this.http.post<any>(`${this.api}/DataSource/ConvertNewConnectionToAvailableDBConnection/`, bodyRequest);

  }

  convertAvailableDBConnectionToNewConnection(workspaceId: string, dataSourceId: string, connectionId: string, payload: {
    dataSourceName: string;
    connectionName: string;
    serverAddress: string;
    portNumber: string;
    dbName: string;
    windowsAuth: boolean;
    username: string;
    password: string;
    commandTimeout: number;
    sqlStatement: string;
  }): Observable<any> {
    const bodyRequest = {
      connectionType: 'Queryable',
      workspaceId,
      dataSourceId,
      connectionId,
      ...payload,
    };
    return this.http.post<any>(`${this.api}/DataSource/ConvertAvailableDBConnectionToNewConnection/`, bodyRequest);

  }

  getIncrementalSetting(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api +'/DataSource/GetIncrementalSetting', bodyRequest);
  }

  updateIncrementalSetting(workspaceId: string, dataSourceId: string, id: string, updated: string,
                           deleted: string, timeMode: string, count: number, isIncremental: boolean): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      isIncremental,
    };
    if(isIncremental){
      bodyRequest['incrementalSetting']= {
        id,
          updated,
          deleted,
          timeMode,
          count,
      };
    }
    return this.http.post<any>(`${this.api}/DataSource/UpdateIncrementalSetting`, bodyRequest);

  }

  createWebServiceConnection(
    workspaceId: string,
    name: string,
    address: string,
    dataTypes: string,
    methodTypes: string,
    authenticationTypes: string,
    body: string,
    username: string,
    password: string,
    requestParameters: { name: string; value: string; type: string }[],
    requestHeaders: { name: string; value: string }[],
    jsonBody: { name: string; value: string }[]
  ): Observable<any> {
    const bodyRequest = {
      workspaceId,
      name,
      address,
      dataType: dataTypes,
      methodType: methodTypes,
      authenticationType: authenticationTypes === 'No Authentication' ? 'None' : 'BasicAuthentication',
      body,
      username,
      password,
      requestParameters: requestParameters.length > 0 ? requestParameters : [],
      requestHeaders: requestHeaders.length > 0 ? requestHeaders : [],
      jsonBody: jsonBody.length > 0 ? jsonBody : [],

    };
  
    return this.http.post<any>(`${this.api}/DataSource/CreateWebServiceConnection/`, bodyRequest);
  }

  createOracleConnection(body: Partial<OracleBodyReq>): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/CreateOracleConnection`, body);
  }

  getOracleConnection(workspaceId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
    };
    return this.http.post<any>(this.api + '/DataSource/GetOracleConnection', bodyRequest);

  }

  updateOracleConnection(body): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/UpdateOracleConnection/`, body);
  }

  createDashboard(datasourceId: string, workSpaceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId: workSpaceId,
      dataSourceId: datasourceId,
    };
    return this.http.post<any>(`${this.api}/Dashboard/CreateDashboard`, bodyRequest);
  }

  uploadFile(workSpaceId: string, uploadType: string, uploadFile: FormData): Observable<any> {
    return this.http.post<any>(`${this.api}/DataSource/UploadFile/${uploadType}/${workSpaceId}`, uploadFile);
  }

  replaceDataSource(uploadFile: FormData, uploadType: string, workspaceId: string): Observable<any> {
    return this.http.post(`${this.api}/DataSource/ReplacementDataSource/${uploadType}/${workspaceId}`, uploadFile);
  }

  uploadFileFromURL(workspaceId: string, url: string): Observable<any> {
    const uploadFile: any = {
      workspaceId,
      url,
    };
    return this.http.post<any>(`${this.api}/DataSource/UploadFileFromURL/`, uploadFile);
  }

  arrayToObjectConvertor(columnsTypes: any): any {
    const obj = {};
    for(const key in columnsTypes) {
      if(key) {
        obj[key] = columnsTypes[key];
      }
    }
    return obj;
  }

  makeNewDashboard(newDashboard: any): Observable<any>  {
    return this.http.post<any>(`${this.api}/Dashboard/CreateDashboard`, newDashboard);
  }

  addDataSourceToDashboard(workspaceId: string, dashboardId: string, dataSourceId: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      dashboardId,
    };
    return this.http.post<any>(`${this.api}/Dashboard/AddDataSourceToDashboard`,bodyRequest);
  }

  getUserDataBaseConnections(workspaceId: string): Observable<any> {
      return  this.http.post<any>(`${this.api}/DataSource/GetUserDBConnections`,{workspaceId});
  }

  getDataBaseConnectionTables(workspaceId: string, dbConnectionId: string) {
    const bodyRequest = {
      workspaceId,
      dbConnectionId,
    };
    return  this.http.post<any>(`${this.api}/DataSource/GetDBConnectionTables`,bodyRequest);
  }

  createSqlServerDataBaseConnection(tableId: string, dbConnectionId: string, workspaceId: string,
    dataSourceName: string, hasRowLimited: boolean, numberOfRowLimited: string,
    hasTopN: boolean, numberOfTopN: string): Observable<any> {
    const bodyRequest = {
      tableId,
      dbConnectionId,
      workspaceId,
      dataSourceName,
      connectionType: 'Selectable',
      hasRowLimited,
      numberOfRowLimited,
      hasTopN,
      numberOfTopN,
    };
    return this.http.post(`${this.api}/DataSource/CreateSQLServerDBConnection`, bodyRequest);
  }

  updateSqlServerDataBaseConnection(workspaceId: string, dataSourceId: string, connectionId: string,
    dbConnectionId: string, dataSourceName: string, tableId: string, hasRowLimited: boolean, numberOfRowLimited: string,
    hasTopN: boolean, numberOfTopN: string, ): Observable<any> {

    const bodyRequest = {
      workspaceId,
      dataSourceId,
      connectionId,
      dbConnectionId,
      dataSourceName,
      tableId,
      hasRowLimited,
      numberOfRowLimited,
      hasTopN,
      numberOfTopN,
    };
    return this.http.post(`${this.api}/DataSource/UpdateSQLServerDBConnection`, bodyRequest);

  }

  replaceExcellWithSqlServerConnection(
    dataSourceId: string,
    workspaceId: string, name: string, serverAddress: string,
    portNumber: string, dbName: string, windowsAuth: boolean,
    username: string, password: string, commandTimeout: number,
    sqlStatement: string): Observable<any> {
      const bodyRequest: ReplaceWithSqlConnectionModel = {
        workspaceId,
        dataSourceId,
        connectionType: 'Queryable',
        connectionDto:{
          name,
          serverAddress,
          portNumber,
          dbName,
          windowsAuth,
          username,
          password,
          sqlStatement,
          commandTimeout,
        },
    };


    return this.http.post(`${this.api}/DataSource/ConvertDataSourceType`, bodyRequest);

  }

  replaceExcellWithSqlServerDataBaseConnection( dataSourceId: string,
    tableId: string, dbConnectionId: string, workspaceId: string,
    dataSourceName: string, hasRowLimited: boolean, numberOfRowLimited: string,
    hasTopN: boolean, numberOfTopN: string): Observable<any> {

    const bodyRequest: ReplaceWithSqlConnectionModel = {
        dataSourceId,
        workspaceId,
        connectionType: 'Selectable',
        connectionSelectableDto:{
          tableId,
          dbConnectionId,
          workspaceId,
          dataSourceName,
          hasRowLimited,
          numberOfRowLimited,
          hasTopN,
          numberOfTopN,
        },
    };

    return this.http.post(`${this.api}/DataSource/ConvertDataSourceType`, bodyRequest);

  }

  checkUpdateDataSourceData(workspaceId: string, previewDataSourceInfo: Partial<PreviewDataSourceInfo>,
                            rowNumber: DataSourceRowNumber, sheetName: string): Observable<any> {
    const bodyRequest = {
      workspaceId,
      dataSourceId: previewDataSourceInfo.dataSourceId,
      filePath: previewDataSourceInfo.filePath,
      fileName: previewDataSourceInfo.fileName,
      rowNumber,
      sheetName,
    };
    return this.http.post(`${this.api}/DataSource/CheckUpdateDataSourceData`,bodyRequest);
  }

  //Replace Excel dataSource with SqlServer Related APIs
  createReplacementSqlServerConnection(dataSourceId: string, workspaceId: string, name: string, 
    serverAddress: string, portNumber: string, dbName: string, windowsAuth: boolean, username: string, 
    password: string, commandTimeout: number, sqlStatement: string) {
    const bodyRequest: ReplaceExcelWithSqlConnectionModelConnectionSelectableDto = {
      workspaceId,
      dataSourceId,
      name,
      serverAddress,
      portNumber,
      dbName,
      windowsAuth,
      username,
      password,
      sqlStatement,
      commandTimeout,
    }
    
    return this.http.post(`${this.api}/DataSource/CreateReplacementSqlServerConnection`, bodyRequest)
  }

  createReplacementSqlServerDBConnection(dataSourceId:string, tableId: string, dbConnectionId:string, workspaceId:string,
    dataSourceName:string, hasRowLimited:boolean, numberOfRowLimited:string, hasTopN:boolean, numberOfTopN:string) {
    const bodyRequest = {
      dataSourceId,
      tableId,
      dbConnectionId,
      workspaceId,
      dataSourceName,
      connectionType: 'Selectable',
      hasRowLimited,
      hasTopN
    }
    
    return this.http.post(`${this.api}/DataSource/CreateReplacementSqlServerDBConnection`, bodyRequest);
  }

  getReplacementSqlServerPreviewData(workspaceId: string, connectionId: string, rowNumber: string) {
    const bodyRequest = {
      workspaceId,
      connectionId,
      rowNumber
    };
    return  this.http.post<any>(`${this.api}/DataSource/GetReplacementSqlServerPreviewData`,bodyRequest);
  }

  deleteReplacementSQLConnectionAndRevokeDataSource(dataSourceId: string, connectionId: string) {
    const bodyRequest = {
      dataSourceId,
      connectionId
    };
    return this.http.post<any>(`${this.api}/DataSource/DeleteReplacementSQLConnectionAndRevokeDataSource`, bodyRequest);
  }

  replaceExcelWithSqlServerDataSource(workspaceId: string, dataSourceId: string, name: string) {
    const bodyRequest = {
      workspaceId,
      dataSourceId,
      name
    }

    return this.http.post(`${this.api}/DataSource/ConvertDataSourceType`, bodyRequest);
  }
}
